import { RRule } from 'rrule';

export const DAY_IN_MILLISECONDS = 86_400_000;
export const DATE_KEY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function createRule(rrule: string, start: string): RRule {
  const parsed = RRule.parseString(`RRULE:${rrule}`);
  if (parsed.freq === undefined) throw new Error('RRULE is missing FREQ');
  return new RRule({ ...parsed, dtstart: dateKeyToUtc(start) });
}

export function laterDate(first: string | null, second: string | null): string | null {
  if (first === null) return second;
  if (second === null) return first;
  return first >= second ? first : second;
}

export function earlierDate(first: string | null, second: string | null): string | null {
  if (first === null) return second;
  if (second === null) return first;
  return first <= second ? first : second;
}

export function dateKeyToUtc(isoDate: string): Date {
  const match = DATE_KEY_PATTERN.exec(isoDate);
  if (!match) throw new Error(`Invalid ISO date: ${isoDate}`);

  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  if (utcToDateKey(date) !== isoDate) throw new Error(`Invalid ISO date: ${isoDate}`);
  return date;
}

export function utcToDateKey(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
